import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from "@mui/material";
import { CustomText, WrapperContainer, } from "@corporate-trip-planner-fe/ui-styles";
var InfoListCard = function (_a) {
    var title = _a.title, sections = _a.sections;
    return (_jsxs(WrapperContainer, { "$background": "#fff", "$borderRadius": "12px", "$padding": "24px", "$textAlign": "left", style: { border: "1px solid #e2ddd4" }, "$flexDirection": "column", children: [_jsx(CustomText, { "$fontSize": "18px", "$fontWeight": "600", "$display": "block", "$textAlign": "left", children: title }), _jsx(Box, { sx: {
                    display: "flex",
                    gap: 2,
                    flexDirection: { xs: "column", md: "row" },
                    mt: 2,
                    alignItems: "flex-start",
                }, children: sections.map(function (section, sIdx) { return (_jsxs(Box, { sx: {
                        width: { xs: "100%", md: "48%" },
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                        pl: { xs: 0, md: 1 },
                        alignSelf: "stretch",
                    }, children: [section.subtitle && (_jsx(CustomText, { "$fontWeight": "600", "$fontSize": "13px", "$display": "block", "$textAlign": "left", "$margin": "0 0 12px 0", style: {
                                letterSpacing: "0.06em",
                                textTransform: "uppercase",
                                color: section.subtitle === "Inclusions" ? "#2e6e4e" : "#c0401a",
                            }, children: section.subtitle })), section.items.map(function (item, iIdx) { return (_jsxs(Box, { sx: { display: "flex", alignItems: "center", mb: 1.5, gap: 1.5 }, children: [_jsx(Box, { sx: { color: section.iconColor, display: "flex", mt: "2px" }, children: section.icon }), _jsx(CustomText, { "$fontSize": "14px", "$color": "#444", "$textAlign": "left", style: { lineHeight: "1.4" }, children: item })] }, iIdx)); })] }, sIdx)); }) })] }));
};
export default InfoListCard;
